import { render, staticRenderFns } from "./PrincipleAbout.vue?vue&type=template&id=5530baca&scoped=true&"
import script from "./PrincipleAbout.vue?vue&type=script&lang=js&"
export * from "./PrincipleAbout.vue?vue&type=script&lang=js&"
import style0 from "./PrincipleAbout.vue?vue&type=style&index=0&id=5530baca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5530baca",
  null
  
)

export default component.exports